// extracted by mini-css-extract-plugin
export default {"tabContent":"sj1moy3oKR","tabContent_widthConstrainted":"GhWAqk6jip"};